import { useState, useEffect } from 'react';

type Orientation = 'portrait' | 'landscape';

interface OrientationInfo {
  orientation: Orientation;
  isPortrait: boolean;
  isLandscape: boolean;
  angle: number;
}

export const useOrientation = (): OrientationInfo => {
  const getOrientation = (): OrientationInfo => {
    const angle = window.screen?.orientation?.angle ?? 0;
    const orientation: Orientation = window.innerHeight > window.innerWidth ? 'portrait' : 'landscape';

    return {
      orientation,
      isPortrait: orientation === 'portrait',
      isLandscape: orientation === 'landscape',
      angle,
    };
  };

  const [orientationInfo, setOrientationInfo] = useState<OrientationInfo>(getOrientation());

  useEffect(() => {
    const handleOrientationChange = () => {
      setOrientationInfo(getOrientation());
    };

    window.addEventListener('resize', handleOrientationChange);
    window.screen?.orientation?.addEventListener('change', handleOrientationChange);

    return () => {
      window.removeEventListener('resize', handleOrientationChange);
      window.screen?.orientation?.removeEventListener('change', handleOrientationChange);
    };
  }, []);

  return orientationInfo;
};
